export default __webpack_public_path__ + "static/media/numeros2.87c6b040.jpg";